import DataTable from "react-data-table-component";
import React, {useEffect, useState} from "react";
import {Col, Form, FormGroup, Input, Label, Row} from "reactstrap";
import {Btn} from "../../AbstractElements";
import {TableActionStyle} from "../../Utils/table";
import SweetAlert from "sweetalert2";
import axios from "axios";
import {API_COURSE_BATCH_CLASS} from "../../api/service";
import {CreateFilterEncoding, CreatePaginationEncoding} from "../../Utils/Base64/request";
import {CountPaginationOffset} from "../../Utils/pagination";
import {useNavigate} from 'react-router-dom';

export const CourseBatchClassDataTable = ({
                                              batchID = 0,
                                              refresh = false,
                                              onRefreshFinish
                                          }) => {
    const [data, setData] = useState([]);
    const [pagination, setPagination] = useState({
        rowsPerPage: 10,
        page: 1,
        totalRows: 10
    })
    const [isLoading, setIsLoading] = useState(false)
    const [filter, setFilter] = useState({
        batch_id: batchID,
        username: "",
        first_name: "",
        last_name: "",
        elective: true
    })


    useEffect(() => {
        if (refresh === true) {
            loadData(pagination.rowsPerPage, 0, {...filter})
            onRefreshFinish()
        }
    }, [refresh])

    const navigate = useNavigate()

    const columns = [
        {
            name: 'ID',
            selector: (row) => row.id,
            sortable: true,
            center: true,
            compact: true,
            serverSort: "id",
        },
        {
            name: 'Topic',
            selector: (row) => row.title,
            sortable: true,
            center: true,
        },
        {
            name: 'Speaker',
            selector: (row) => row.speaker,
            sortable: true,
            center: true,
        },
        {
            name: 'Action',
            selector: (row) => tableAction(row.id),
            sortable: true,
            center: true,
        },
    ]

    const tableAction = (id) => {
        return (<div>
                    <span>
                        <Btn attrBtn={{
                            onClick: () => handleDelete(id),
                            style: TableActionStyle,
                            className: 'btn btn-danger btn-xs',
                            type: 'button'
                        }}>Remove</Btn>
                    </span>
        </div>)
    }

    const handleDelete = (id) => {
        SweetAlert.fire({
            title: 'Delete?',
            html: 'Are you sure want to delete this?',
            icon: 'error',
            cancelButtonText: 'Cancel',
            confirmButtonText: 'Delete',
            reverseButtons: true,
            showCancelButton: true,
        }).then((e) => {
            if (e.isConfirmed) {
                axios.delete(API_COURSE_BATCH_CLASS + "/?id=" + id).then(r => {
                    if (r.status === 200) {
                        return r.data["data"]
                    }
                }).then(json => {
                    SweetAlert.fire({
                        title: 'Success!',
                        text: 'Data Deletion Completed!',
                        icon: 'success'
                    }).then(() => {
                        loadData(10, 0, {...filter})
                    })
                }).catch(() => {
                    SweetAlert.fire({
                        title: 'Failed!',
                        text: 'Data Deletion Failed!',
                        icon: 'error'
                    })
                })
            }
        });


    }

    const loadData = (limit = 10, offset = 0, filter = {}) => {
        setIsLoading(true);

        if (batchID !== 0) {
            axios.get(API_COURSE_BATCH_CLASS + "/?pagination=" + CreatePaginationEncoding(limit, offset) + "&filter=" + CreateFilterEncoding(filter)).then(r => {
                if (r.status === 200) {
                    return r.data["data"]
                }
            }).then(json => {
                if (json.data) {
                    setData(json.data.length > 0 ? json.data : [])
                    setPagination({
                        ...pagination, totalRows: json.count.all
                    })
                } else {
                    setData([])
                    setPagination({
                        ...pagination, totalRows: 0
                    })
                }
            }).finally(() => {
                setIsLoading(false);
            })
        } else {
            setData([])
            setPagination({
                ...pagination, totalRows: 0
            })
            setIsLoading(false);
        }
    }


    useEffect(() => {
        loadData(10, 0, filter)
    }, [])

    useEffect(() => {
        setFilter({...filter, batch_id: batchID})
        loadData(10, 0, {...filter, batch_id: batchID})
    }, [batchID])

    const onSearchSubmit = (e) => {
        e.preventDefault()
        loadData(pagination.rowsPerPage, 0, {...filter})
    }

    const onSort = (column, sortDir) => {
        console.log(column, sortDir);
    }

    const onPageChange = page => {
        loadData(pagination.rowsPerPage, CountPaginationOffset(page, pagination.rowsPerPage), {...filter})
        setPagination({
            ...pagination, page: page
        })
    };

    const onPaginationRowsChangePage = (newPerPage, page) => {
        loadData(newPerPage, CountPaginationOffset(page, newPerPage))
        setPagination({
            ...pagination, page: page, rowsPerPage: newPerPage
        })
    }

    return <>
        <Col md={12} className={"m-t-15"}>
            <Form onSubmit={onSearchSubmit}>
                <Row className="justify-content-start align-items-end">
                    <Col md="auto">
                        <FormGroup className="row">
                            <Label htmlFor="exampleFormControlSelect3">Search</Label>
                            <Col sm="12">
                                <Input className="form-control" type="text" placeholder={"Search Here"}
                                       onChange={(e) => {
                                           setFilter({
                                               ...filter,
                                               title: e.target.value
                                           })
                                       }}/>
                            </Col>
                        </FormGroup>
                    </Col>
                    <Col md="auto">
                        <Label htmlFor="exampleFormControlSelect3"></Label>
                        <FormGroup className="row">
                            <Btn attrBtn={{color: "primary", className: "m-r-15", onClick: onSearchSubmit}}>Search</Btn>
                        </FormGroup>
                    </Col>
                </Row>
            </Form>
        </Col>

        <Col md={12}>
            <DataTable
                sortServer
                pagination
                paginationServer

                data={data}
                columns={columns}
                progressPending={isLoading}
                onSort={onSort}
                paginationTotalRows={pagination.totalRows}
                onChangeRowsPerPage={onPaginationRowsChangePage}
                onChangePage={onPageChange}
                striped={true}
                center={true}
            />
        </Col>

    </>
}